module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon5.42ac7aa4.png";